module.exports = __webpack_public_path__ + "d6170bd8aa53b02158f9051aa014adf9.pdf";